import MetricProfileForm from './MetricProfileForm'

export default MetricProfileForm
